import React, { useState } from 'react';
import api from '../../services/api';
import TTSQueueMonitor from './TTSQueueMonitor';
import './Admin.css';

const TTSQueue = () => {
  const [text, setText] = useState('');
  const [voice, setVoice] = useState('nl_NL-pim-medium');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const voices = [
    { id: 'nl_NL-pim-medium', name: '🇳🇱 Pim (Man, Nederlands)' },
    { id: 'nl_NL-ronnie-medium', name: '🇳🇱 Ronnie (Man, Energiek)' },
    { id: 'nl_BE-nathalie-medium', name: '🇧🇪 Nathalie (Vrouw, Warm)' },
    { id: 'nl_BE-rdh-medium', name: '🇧🇪 Ruben (Man, Belgisch)' },
    { id: 'nl_NL-mls-medium', name: '🇳🇱 MLS (Gemengd, Nederlands)' },
    { id: 'nl_NL-mls_5809-low', name: '🇳🇱 Speaker 5809' },
    { id: 'nl_NL-mls_7432-low', name: '🇳🇱 Speaker 7432' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!text.trim()) {
      setMessage('Voer tekst in om af te spelen');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await api.post('/tts/queue', {
        text: text.trim(),
        voice
      });

      setMessage(`TTS toegevoegd aan queue! Speelt af na het huidige nummer. (Positie: ${response.data.queuePosition})`);
      setMessageType('success');
      setText('');
    } catch (error) {
      setMessage(error.response?.data?.error || 'Fout bij toevoegen TTS');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tts-queue-page">
      <div className="page-header">
        <h1><i className="fas fa-microphone"></i> TTS Queue</h1>
        <p className="page-subtitle">Voeg tekst-naar-spraak berichten toe die na het huidige nummer afgespeeld worden</p>
      </div>

      <div className="tts-form-container">
        <form onSubmit={handleSubmit} className="tts-form">
          <div className="form-group">
            <label htmlFor="voice">
              <i className="fas fa-user-tie"></i> Stem
            </label>
            <select
              id="voice"
              value={voice}
              onChange={(e) => setVoice(e.target.value)}
              className="form-select"
            >
              {voices.map(v => (
                <option key={v.id} value={v.id}>{v.name}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="text">
              <i className="fas fa-comment"></i> Tekst om af te spelen
            </label>
            <textarea
              id="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Bijvoorbeeld: Je luistert naar AudioCore, jouw 24/7 radiostation!"
              rows="5"
              maxLength="500"
              className="form-textarea"
            />
            <small className="char-counter">{text.length}/500 karakters</small>
          </div>

          {message && (
            <div className={`message ${messageType}`}>
              <i className={`fas fa-${messageType === 'success' ? 'check-circle' : 'exclamation-circle'}`}></i>
              {message}
            </div>
          )}

          <button 
            type="submit" 
            className="btn-primary btn-large"
            disabled={loading || !text.trim()}
          >
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Toevoegen...
              </>
            ) : (
              <>
                <i className="fas fa-paper-plane"></i> Voeg toe aan queue
              </>
            )}
          </button>
        </form>

        <div className="tts-info-box">
          <h3><i className="fas fa-info-circle"></i> Hoe werkt het?</h3>
          <ul>
            <li><strong>Handmatig:</strong> TTS speelt alleen af als je het hier toevoegt</li>
            <li><strong>Timing:</strong> TTS wordt afgespeeld NA het huidige nummer</li>
            <li><strong>7 Stemmen:</strong> Kies uit Belgisch/Nederlands, man/vrouw varianten</li>
            <li><strong>Max 500 karakters:</strong> Korte, duidelijke berichten werken het beste</li>
          </ul>
        </div>
      </div>

      {/* Live queue monitor */}
      <div style={{ marginTop: '40px' }}>
        <TTSQueueMonitor />
      </div>
    </div>
  );
};

export default TTSQueue;
